// Site configuration for Xicano Rights Union

export const siteConfig = {
  name: "Xicano Rights Union",
  acronym: "XRU",
  tagline: "Defending Rights. Demanding Justice. Building Power.",
  description: "The Xicano Rights Union is dedicated to ensuring the political, educational, social, and economic equality of Xicano and Indigenous peoples through advocacy, litigation, cultural education, and youth empowerment programs.",
  email: "xicanorightsunion@gmail.com",
  location: "Twin Cities, Minnesota",
  established: "July 2025",
  logo: "https://customer-assets.emergentagent.com/job_civil-rights-union/artifacts/gdq4cr8f_Picsart_26-01-19_02-11-07-580.png",
  ogImage: "https://customer-assets.emergentagent.com/job_civil-rights-union/artifacts/gdq4cr8f_Picsart_26-01-19_02-11-07-580.png",
  heroImage: "https://customer-assets.emergentagent.com/job_b5c5d61c-27e6-4f10-952e-ab16d5b009c5/artifacts/mtqzmubd_FB_IMG_1768316262771.jpg",
  socialLinks: {
    facebook: "https://www.facebook.com/share/16a5rYBHCC/",
    instagram: "https://www.instagram.com/xicanorightsunion?igsh=NHFxMWx4dHJhZnln"
  },
  videoFeature: {
    title: "American Homeboy",
    description: "A powerful documentary exploring Xicano identity, culture, and the ongoing struggle for recognition and rights in America.",
    tubiUrl: "https://link.tubi.tv/IYIzyZ0ITZb",
    embedUrl: "https://tubitv.com/embed/100009527"
  },
  communityVideo: {
    title: "Our Movement",
    url: "https://customer-assets.emergentagent.com/job_civil-rights-union/artifacts/c21f23om_FB_VID_6675918943092613299.mp4"
  }
};

export const issues = [
  {
    id: 1,
    title: "Civil Rights & Justice",
    description: "Advocating for racial equity and justice through policy change, legal action, and community organizing. We investigate civil and human rights violations and hold institutions accountable.",
    icon: "Scale",
    stat: "Protecting the rights of our community"
  },
  {
    id: 2,
    title: "Cultural & Historical Education",
    description: "Teaching the rich history of Xicano and Indigenous peoples, from ancient Mesoamerican civilizations to the modern Chicano Movement. Knowledge of our past empowers our future.",
    icon: "BookOpen",
    stat: "Preserving our ancestral knowledge"
  },
  {
    id: 3,
    title: "Youth Enrichment Programs",
    description: "Empowering the next generation through mentorship, cultural education, and leadership development. Our youth programs instill pride, knowledge, and skills for success.",
    icon: "GraduationCap",
    stat: "Investing in future leaders"
  },
  {
    id: 4,
    title: "Indigenous Rights",
    description: "Defending the sovereignty, land rights, and cultural preservation of Indigenous peoples. We work to ensure treaty rights are honored and sacred sites are protected.",
    icon: "Landmark",
    stat: "Honoring ancestral obligations"
  },
  {
    id: 5,
    title: "Police Accountability",
    description: "Demanding transparency, accountability, and reform in law enforcement. We support families affected by police violence and advocate for systemic change.",
    icon: "Shield",
    stat: "Fighting for accountability"
  },
  {
    id: 6,
    title: "Community Empowerment",
    description: "Building stronger communities through organizing, mutual aid, and cultural celebration. We create spaces for our gente to connect, grow, and thrive together.",
    icon: "Users",
    stat: "Juntos somos más fuertes"
  }
];

export const aboutContent = {
  mission: "The Xicano Rights Union works to ensure the political, educational, social, and economic equality of all persons of Xicano and Indigenous heritage, and to eliminate race-based discrimination through advocacy, litigation, education, and grassroots organizing.",
  vision: "A nation where Xicano and Indigenous peoples live free from discrimination, with full recognition of their civil and human rights, and where systemic oppression has been dismantled.",
  values: [
    "Justice — We pursue accountability for civil and human rights violations",
    "Equity — We fight for equal treatment under the law and in society",
    "Solidarity — We stand united with all communities facing oppression",
    "Integrity — We operate with transparency and ethical commitment",
    "Empowerment — We build community power through education and organizing"
  ],
  history: "Founded in 2025 in the Twin Cities, Minnesota, the Xicano Rights Union emerged in response to ongoing civil and human rights violations affecting Xicano and Indigenous communities. Our founders recognized the urgent need for an organization dedicated to investigating injustices, advocating for policy reform, and holding institutions accountable for discrimination and human rights abuses."
};

export const partners = [
  {
    id: 1,
    name: "Arizona Taco Co.",
    description: "A community-minded business supporting our mission through partnership and solidarity with the Xicano community.",
    website: "https://arizonatacocompany.com/",
    type: "sponsor"
  },
  {
    id: 2,
    name: "Mystery Machine TC",
    description: "A Twin Cities collective committed to cultural preservation and community empowerment.",
    website: "https://linktr.ee/mysterymachinetc",
    type: "community"
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "The Xicano Rights Union gave my family hope when we had none. They stood with us, fought for us, and helped us find justice.",
    author: "María S.",
    role: "Community Member"
  },
  {
    id: 2,
    quote: "Finally, an organization that understands our struggles and has the expertise to create real change. XRU is essential for our community.",
    author: "Carlos R.",
    role: "Advocate"
  },
  {
    id: 3,
    quote: "Their commitment to holding institutions accountable gives me hope for a more just future for my children and grandchildren.",
    author: "Elena M.",
    role: "Community Elder"
  }
];

export const actions = [
  {
    title: "Report a Violation",
    description: "If you or someone you know has experienced discrimination or a civil or human rights violation, report it to us.",
    link: "/contact",
    icon: "AlertTriangle"
  },
  {
    title: "Become a Member",
    description: "Join the movement. Your membership supports our advocacy, litigation, and community programs.",
    link: "/contact",
    icon: "UserPlus"
  },
  {
    title: "Donate",
    description: "Your contribution directly funds our fight for justice and equality.",
    link: "/contact",
    icon: "Heart"
  },
  {
    title: "Volunteer",
    description: "Lend your time and skills to advance civil and human rights in your community.",
    link: "/contact",
    icon: "Hand"
  }
];
